import { callApi, callApiProxyCallback } from "../api";
import moment from "moment";

export const fetchGetAccounts = () => callApi("accounts", null, "GET");

export const fetchGetPortfolio = (cuenta, date) =>
  callApi(`accounts/${encodeURI(cuenta)}/portfolio?date=${date}&v2=true&v3=true`, null, "GET");

export const fetchGetPortfolioNoLogs = (cuenta) => callApi(`accounts/${cuenta}/portfolioNoLogs`, null, "GET");

export const fetchGetAccountInfo = (accountId) => callApi(`account/info?accountId=${accountId}`, null, "GET");

export const fetchGetActivity = (cuenta, currency, filter) => {
  const from = moment(filter.desde).format("YYYY-MM-DD");
  const to = moment(filter.hasta).format("YYYY-MM-DD");
  return callApi(`accounts/${cuenta}/activity/cash/${currency}/?from=${from}&to=${to}`, null, "GET");
};

export const fetchGetActivityProduct = (cuenta, assetId, filter) => {
  const from = moment(filter.desde).format("YYYY-MM-DD");
  const to = moment(filter.hasta).format("YYYY-MM-DD");
  return callApi(`accounts/${cuenta}/activity/asset/${assetId}/?from=${from}&to=${to}`, null, "GET");
};

export const fetchGetAccountBanks = (cuenta) => callApi(`accounts/${cuenta}/bankAccounts`, null, "GET");

export const getArchivesTypes = () => callApi(`person/archivesTypes`, null, "GET");

export const GetDigitalLinks = (body) => callApi("accounts/GetDigitalLinks", body, "POST");

export const getClientPositionDigital = (body) => callApi("accounts/getClientPositionDigital", body, "POST");

export const getClientHistoryAUM = (body) => callApi("accounts/getClientHistoryAUM", body, "POST");

export const getClientHistoryPerformance = (body) =>
  callApi("accounts/getClientHistoryPerformance", body, "POST");

export const getMonthsPositionReport = (body) => callApi("accounts/getMonthsPositionReport", body, "POST");

export const GetDigitalReprofile = () => callApi("accounts/getDigitalReprofile", null, "POST");

export const getAccountStatement = async (numCli, month, year) =>
  callApi(`accounts/${numCli}/activity/?month=${month}&year=${year}`, null, "GET");

export const getPersonInfo = () => callApi("accounts/personInfo", null, "GET");

export const setPersonInfo = (body) => callApi("accounts/personInfo", body, "POST");

export const getFutureIncome = (body) => {
  const from = moment(body.from).format("YYYY-MM-DD");
  const to = moment(body.to).format("YYYY-MM-DD");
  return callApi(`accounts/${body.cuenta}/activity/cashFlow?from=${from}&to=${to}`, null, "GET");
};

export const getPortfolioCSV = (payload) => callApi("accounts/portfolio/reportCSV", payload, "POST");

export const getPortfolioXLS = (payload) => callApi("accounts/portfolio/reportXLS", payload, "POST");

export const getHistoryCSV = (payload) => callApi("accounts/history/reportCSV", payload, "POST");

export const getHistoryXLS = (payload) => callApi("accounts/history/reportXLS", payload, "POST");

export const fetchProductActivityPDF = (payload) => callApi("accounts/history/activitypdf", payload, "POST");

export const fetchInProcesOrderPDF = (payload) =>
  callApi(
    "orders/inprocesspdf",
    { ...payload, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    "POST"
  );

export const fetchOpenId = (payload) => callApi("openID", payload, "POST");

export const getPersonBankAccount = (payload) => callApi("person/relatedAccounts?v2=true", payload, "POST");

export const getBankAccountBalance = (payload) => callApi("person/bankAccounts/balance", payload, "POST");
